/*!
  Pioneer WFRIA Composer v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["Composer"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("Composer") < 0) {
    window.__PIONEER_GLOBAL__.components.push("Composer");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

import PropTypes from "prop-types";
import { cloneElement } from "react";
/**
 * Recursively build up components from props.components and accumulate render prop results.
 * @param {function} render
 * @param {Array.<Object>} remainingComponents
 * @param {Object} combinedResults
 * @returns {ReactElement}
 */

function renderRecursive(render, remainingComponents, combinedResults) {
  combinedResults = combinedResults || {};
  const componentDefinition = remainingComponents[0]; // Once components are exhausted, we can render out the combinedResults object.

  if (!componentDefinition) {
    return render(combinedResults);
  }

  const componentName = Object.keys(componentDefinition)[0];
  const component = componentDefinition[componentName];
  /**
   * Continue recursion for remaining components.
   * @param {*} value
   */

  function nextRender(value) {
    combinedResults[componentName] = value;
    return renderRecursive(render, remainingComponents.slice(1), combinedResults);
  } // if it's a function, call it and pass the combined results


  if (typeof component === "function") {
    return component({
      results: combinedResults,
      render: nextRender
    });
  } // Enhance the component's props with the render prop.


  return /*#__PURE__*/cloneElement(component, {
    children: nextRender
  });
}
/**
 * It allows you to compose render prop components into a single one to avoid
 * excessive nesting.
 */


export default function Composer(_ref) {
  let {
    children,
    components
  } = _ref;
  return renderRecursive(children, components);
}
Composer.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.object).isRequired // eslint-disable-line react/forbid-prop-types

} : {};